<template>
  <div class="container_wrap">
    <div class="layout_main layout">
      <Breadcrumbs title="直播课堂"></Breadcrumbs>
      <div class="categoryList">
        <div class="list clearfix"></div>
      </div>
      <div class="course_one Multiline">
        <div class="main_body">
          <div class="list" style=""><!--ms-for:($index,el) in @List-->
            <div class="item"><a class="img" target="_blank"
                href="https://www.ttcdw.cn/p/uc/studentCommand/901257794025365504" title="《中华人民共和国爱国主义教育法》解读"><img
                  src="https://rms.guorent.com/dev/upload/article/3D2F146499A0ACF073F2FA2D9B9D2E62/17273344851.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">《中华人民共和国爱国主义教育法》解读</a>
                <p class="item_name">主讲人：姚荣</p>
                <div class="item_detail">2024-09-27 19:00-19:40</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/56682387"
                title="专业技术，为家庭教育指导赋能"><img
                  src="https://rms.guorent.com/dev/upload/article/1BF6203208FAD467DECC06779ED04C53/1727227345.png"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">专业技术，为家庭教育指导赋能</a>
                <p class="item_name">主讲人：付丽旻</p>
                <div class="item_detail">2024-09-24 19:00-21:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://www.ttcdw.cn/p/uc/studentCommand/889266650262642688" title="公益直播来啦！新学期起航：怎样让孩子爱上学习"><img
                  src="https://rms.guorent.com/dev/upload/article/8D51A261D974412378B8AB1E35426994/1724314865.png"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">公益直播来啦！新学期起航：怎样让孩子爱上学习</a>
                <p class="item_name">主讲人：边玉芳</p>
                <div class="item_detail">2024-08-23 19:00-19:40</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://www.ttcdw.cn/p/uc/studentCommand/800908818391535616" title="家庭劳动教育与品德培养——让孩子在劳动中成长"><img
                  src="https://rms.guorent.com/dev/upload/article/D21987F596C750D6278D398BC1BDB702/1703490736.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">家庭劳动教育与品德培养——让孩子在劳动中成长</a>
                <p class="item_name">主讲人：戴君</p>
                <div class="item_detail">2023-12-30 19:00-19:40</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/49311940"
                title="怎么说孩子才会听，怎么听孩子才会说"><img
                  src="https://rms.guorent.com/dev/upload/article/3CAACD642A6B3A499D6112C0720B58DE/1700812265.png"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">怎么说孩子才会听，怎么听孩子才会说</a>
                <p class="item_name">主讲人：吴霖</p>
                <div class="item_detail">2023-11-26 19:00-19:40</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://ceat.gensee.com:443/webcast/site/vod/play-3ec7a09af0b144bdbd90b0ad2f61abe1"
                title="品味家教经典，成就孩子一生"><img
                  src="https://rms.guorent.com/dev/upload/article/BF0014ABABA1C72C8B64F2020EECF440/1698313538.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">品味家教经典，成就孩子一生</a>
                <p class="item_name">主讲人：王大龙</p>
                <div class="item_detail">2023-10-29 19:00-19:40</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/92550525"
                title="开学季——如何激发孩子的学习动力"><img
                  src="https://rms.guorent.com/dev/upload/article/B29344A4B0F1665CDD3D323740507712/1695343807.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">开学季——如何激发孩子的学习动力</a>
                <p class="item_name">主讲人：陆士桢</p>
                <div class="item_detail">2023-09-25 19:00-20:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://ceat.gensee.com:443/webcast/site/vod/play-178aa628107544bd969c1f7ddcd89ce6"
                title="开学第一课 如何让学生收心 快速进入学习状态"><img
                  src="https://rms.guorent.com/dev/upload/article/36FAF11EE47C0D590772577F9B9FA736/1692233165.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">开学第一课 如何让学生收心
                  快速进入学习状态</a>
                <p class="item_name">主讲人：宗春山</p>
                <div class="item_detail">2023-08-25 19:00-20:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/33901961"
                title="暑期生活巧规划，自控能力大提升"><img
                  src="https://rms.guorent.com/dev/upload/article/DDC1136F21E16EB6E51B2CE56D421413/1689673176.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">暑期生活巧规划，自控能力大提升</a>
                <p class="item_name">主讲人：付丽旻</p>
                <div class="item_detail">2023-07-29 19:00-20:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/65406581"
                title="家长如何帮孩子度过考前焦虑"><img
                  src="https://rms.guorent.com/dev/upload/article/8204A1AAAD293C9F4185603FD5E6811E/1686538209.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">家长如何帮孩子度过考前焦虑</a>
                <p class="item_name">主讲人：林翔宇</p>
                <div class="item_detail">2023-06-24 19:00-20:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://ceat.gensee.com:443/webcast/site/vod/play-4706e6463c1241b3822805b6b8f592fc"
                title="如何与青春期孩子相处——青春期孩子的心理特征与父母应对"><img
                  src="https://rms.guorent.com/dev/upload/article/DC43DC11FB5E79554211D08757828A19/1684312577.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">如何与青春期孩子相处——青春期孩子的心理特征与父母应对</a>
                <p class="item_name">主讲人：冷静</p>
                <div class="item_detail">2023-05-27 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://ceat.gensee.com:443/webcast/site/vod/play-d3e313821f3e4909a7fb022edac0b360"
                title="家长如何帮孩子提高社会交往能力"><img
                  src="https://rms.guorent.com/dev/upload/article/10C92108C3BF6D4CF4699D62252F1002/1681871467.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">家长如何帮孩子提高社会交往能力</a>
                <p class="item_name">主讲人：彭兴顺</p>
                <div class="item_detail">2023-04-22 19:00-20:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/11698284"
                title="家长在孩子学习中的角色定位"><img
                  src="https://rms.guorent.com/dev/upload/article/EE08E05DBFD5CB0EA9BB1983E3DE7378/1678432782.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">家长在孩子学习中的角色定位</a>
                <p class="item_name">主讲人：王晓春</p>
                <div class="item_detail">2023-03-11 10:00-11:00</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/67492565"
                title="新时期下家庭教育的挑战与应对"><img
                  src="https://rms.guorent.com/dev/upload/article/7B5AFC6BBC814B17F784916BE41DE5AE/1677574118.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">新时期下家庭教育的挑战与应对</a>
                <p class="item_name">主讲人：逄霞</p>
                <div class="item_detail">2023-02-25 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/32092568"
                title="家庭教育起点——全面认知和保护儿童权利"><img
                  src="https://rms.guorent.com/dev/upload/article/B73543D59F59665384FBD930D2304B67/1673415459.jpg"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">家庭教育起点——全面认知和保护儿童权利</a>
                <p class="item_name">主讲人：李婷</p>
                <div class="item_detail">2023-01-14 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/75005020"
                title="如何缓解孩子的备考焦虑"><img
                  src="https://rms.guorent.com/dev/upload/article/3C233C3ED5F3B09C49A9FC31EAA76CC4/1671863216.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">如何缓解孩子的备考焦虑</a>
                <p class="item_name">主讲人：袁湛江</p>
                <div class="item_detail">2022-12-17 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="http://training.ttcdw.cn/training/site/v/12241078"
                title="关注心理健康，激活孩子内驱力"><img
                  src="https://rms.guorent.com/dev/upload/article/A398D995C01CCC9E9D4ADD84AFE406E1/1669106789.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">关注心理健康，激活孩子内驱力</a>
                <p class="item_name">主讲人：付丽旻</p>
                <div class="item_detail">2022-11-26 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="http://training.ttcdw.cn/training/site/v/76215144"
                title="化解亲子冲突 做“智慧”家长"><img
                  src="https://rms.guorent.com/dev/upload/article/5B7A3577CF4B99C71AA8B90515A86DA9/1666850729.jpg"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">化解亲子冲突 做“智慧”家长</a>
                <p class="item_name">主讲人：蓝婷婷</p>
                <div class="item_detail">2022-10-29 19:00-20:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank"
                href="https://training.ttcdw.cn/training/site/v/59273380?sec=MD5&amp;nickname=%E6%9D%A8%E8%8A%B9&amp;token=1a100d2c0dab19c4430e7d73762b3423"
                title="学校如何落实家庭教育指导工作"><img
                  src="https://rms.guorent.com/dev/upload/article/BD32802E91817388818ABC75155E507F/1666231904.png"></a>
              <div class="item_dl"><a target="_blank" class="item_title hover_theme color_1577FE_hover">学校如何落实家庭教育指导工作</a>
                <p class="item_name">主讲人：洪明</p>
                <div class="item_detail">2022-10-18 09:00-11:30</div>
              </div>
            </div><!--for770095552862-->
            <div class="item"><a class="img" target="_blank" href="https://training.ttcdw.cn/training/site/v/53157326"
                title="预防沉迷，引导孩子正确使用电子产品"><img
                  src="https://rms.guorent.com/dev/upload/article/734EBFBA845FF97C59241C991A145D0B/1663120172.png"></a>
              <div class="item_dl"><a target="_blank"
                  class="item_title hover_theme color_1577FE_hover">预防沉迷，引导孩子正确使用电子产品</a>
                <p class="item_name">主讲人：杜建群</p>
                <div class="item_detail">2022-09-17 19:00-20:00</div>
              </div>
            </div><!--for770095552862--><!--ms-for-end:-->
          </div>
          <div class="page clearfix" align="center">
            <!-- 分页组件 -->
            <Pagination :total-items="totalItems" :items-per-page="itemsPerPage" :current-page="currentPage"
              @page-changed="handlePageChange" />
            <!-- <div class="page-wrapper-out">
                <div class="page-wrapper-inner clearfix" id="page-wrapper"><a href="?title=&amp;pageNum=1">首页</a>&nbsp;<a
                    style="background:#cc0000;border-color:#cc0000;color:#fff;">1</a>&nbsp;<a
                    href="?title=&amp;pageNum=2">2</a>&nbsp;<a href="?title=&amp;pageNum=2" class="next"> &gt; </a>&nbsp;<a
                    href="?title=&amp;pageNum=2" class="next"> &gt;| </a></div>
              </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from './component/breadcrumb.vue';
import Pagination from './component/pagination.vue';
export default {
  name: 'NetworkingIndex',
  components: {
    Breadcrumbs,
    Pagination
  },
  data() {
    return {
      type: this.$route.params.type,
      // 数据可以根据实际需要进行调整
      items: [
        { title: '山西省第三届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/983123849693712384' },
        { title: '山西省第二届家庭教育指导技能大赛', link: 'https://org.ttcdw.cn/project/903439760222658560' }
      ],
      totalItems: 20, // 总条数
      currentPage: 1, // 当前页码
      itemsPerPage: 10 // 每页条数
    };
  },
  computed: {
    // 根据 type 动态计算标题
    computedTitle() {
      const titleMap = {
        0: '技能大赛',
        1: '大赛相关',

      };
      return titleMap[this.type];
    }
  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛';
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      // 在这里可以添加逻辑来处理页面变化，比如重新加载数据
      console.log(`当前页码: ${this.currentPage}`);
    }
  }
};

</script>
<style lang="scss" scoped>
.container_wrap {
  width: 100%;
  min-width: 1200px;
  overflow: hidden;

  .layout_main {
    padding: 20px 0 30px 0;

    .categoryList {
      padding-top: 20px;
      margin-bottom: 10px;

      .clearfix:before,
      .clearfix:after {
        content: "";
        display: table;
      }

      .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
      }


    }

    .Multiline {
      width: 100%;

      .main_body {
        padding-top: 30px;
        padding-bottom: 15px;



        .list {
          width: 120%;
          display: flex;
          flex-wrap: wrap;
        }
      }

      .item {
        margin-bottom: 30px;
        width: 290px;
        margin-right: 13px;

        a {
          display: block;
          position: relative;
          width: 100%;


        }

        .img {
          width: 290px;
          height: 162px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item_dl {
          padding-top: 17px;

          .item_title {

            height: 24px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;

          }

          .item_name {
            font-size: 14px;
            line-height: 20px;
            font-weight: 400;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
          }

          .item_detail {
            max-height: 72px;
            margin-top: 4px;
            line-height: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #505050;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }

      }

      a {
        display: block;
        position: relative;
      }
    }
  }

  .layout {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>